import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import RowStyleMenu from './RowStyleMenu';
import { Button } from './ui/button';
import { GripVertical, Trash2 } from 'lucide-react';

function TextBlockSection({ block, onUpdate, onRemove }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: block.id, data: { type: 'section' } });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    ...(block.color ? { borderLeft: `5px solid ${block.color}` } : {}),
  };

  // Größe nach dem Ziehen am Resize-Griff speichern
  const handleResizeEnd = (e) => {
    const el = e.target;
    const w = el.style.width;
    const h = el.style.height;
    if ((w && w !== block.width) || (h && h !== block.height)) {
      onUpdate({ ...block, width: w || block.width, height: h || block.height });
    }
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="text-block-section mb-8 bg-white rounded-lg shadow-sm border border-slate-200"
    >
      <div className="flex items-center justify-between p-3 bg-slate-50 border-b border-slate-200 rounded-t-lg">
        <div className="flex items-center gap-2">
          <div
            {...attributes}
            {...listeners}
            className="drag-handle cursor-grab active:cursor-grabbing text-slate-400 hover:text-slate-600 no-print"
            data-testid="textblock-drag-handle"
          >
            <GripVertical className="h-5 w-5" />
          </div>
          <span className="text-sm font-semibold text-slate-500">Notiz</span>
        </div>
        <div className="flex items-center gap-1 no-print">
          <RowStyleMenu showFormat={false} color={block.color || null} onChange={(s) => onUpdate({ ...block, color: s.color })} />
          <Button variant="ghost" size="sm" onClick={onRemove} className="text-slate-600 hover:text-red-600" data-testid="remove-textblock-button">
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <div className="p-4">
        <textarea
          value={block.text || ''}
          onChange={(e) => onUpdate({ ...block, text: e.target.value })}
          onMouseUp={handleResizeEnd}
          placeholder="Notizen, Hinweise, Logistik … (Ecke unten rechts zum Vergrößern ziehen)"
          style={{
            width: block.width || '100%',
            height: block.height || '120px',
            resize: 'both',
            minHeight: '60px',
            minWidth: '200px',
            maxWidth: '100%',
          }}
          className="block border border-slate-200 rounded p-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-600"
          data-testid="textblock-textarea"
        />
      </div>
    </div>
  );
}

export default TextBlockSection;
